import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';

import type { SyiUseDispatch } from '../reducers';
import {
    CatSuggestionResponse,
    CatSuggestionResponseItem,
    clickContinueCategoryThunk,
    getPageStateThunk,
    updateSyi,
} from '../reducers/syi';
import { trackV2 } from './common-utils';
import { fetchOrThrow, dtlSyi, AIsuggestType } from './dtl-syi';
import joinExperimentsToString from '@gumtree/shared/src/util/join-experiments-to-string';

export function generatorSearchWords(value: string) {
    let cleaned = value.replace(/[^a-zA-Z0-9\-]/g, ' ');
    cleaned = cleaned.replace(/\s+/g, ' ');
    return cleaned.trim();
}

export default class CategorySuggestion {
    constructor(private dispatch: SyiUseDispatch) {}

    async getSuggestions(searchText: string, isAiFlow?: boolean, type?: AIsuggestType) {
        if (searchText.length <= 2) {
            this.dispatch(updateSyi({ catList: null }));
            return;
        }

        const { baseConfig } = this.dispatch(getPageStateThunk());

        const headers = new Headers();
        const experiments = joinExperimentsToString(window.growthbook);
        experiments && headers.set('experiments', experiments);
        let catList;
        if (isAiFlow && type) {
            catList = await dtlSyi.getCategorySuggestions(searchText, type);
        } else {
            const resp = await fetchOrThrow(
                `${baseConfig.sellerUrl}/api/category/suggest?${new URLSearchParams({
                    input: generatorSearchWords(searchText),
                })}`,
                { headers },
                {
                    serviceName: 'seller',
                    path: '/api/category/suggest',
                    method: 'GET',
                }
            );
            catList = (await resp.json()) as CatSuggestionResponse;
        }

        // Compatibility handling for null cases
        if (!catList.categories) {
            catList = { categories: [] };
        }
        // append index to each category
        if (catList.categories) {
            catList.categories.forEach((cat, index) => {
                cat.index = index;
            });
        }
        trackGA4Event<GA4.PostAdInteractionEvent>({
            event: 'ad_posted_form_interactions',
            formName: 'syi-form',
            formStep: 'change category search word[input]',
            searchWord: searchText,
            categories: catList?.categories
                ? JSON.stringify(
                      catList.categories.map(({ id, displayName, tree }) => ({
                          id,
                          displayName,
                          tree,
                      }))
                  )
                : undefined,
        });

        this.showSuggestions(catList);
    }

    showSuggestions(catList: CatSuggestionResponse) {
        this.dispatch(updateSyi({ catList }));

        trackV2('syi-searchCategorySuggestions', undefined, {
            u: {
                suggestCount: catList.categories.length || 0,
            },
        });
    }

    selectSuggestion(cat: CatSuggestionResponseItem, index: number) {
        trackV2('syi-selectCategorySuggestions', 'PostAdFromKeyword', {
            u: {
                suggestIndex: index,
            },
        });

        const hiddenInput = document.querySelector('[name=categoryId]') as HTMLInputElement;
        hiddenInput.value = `${cat.id}`;

        this.dispatch(
            clickContinueCategoryThunk(
                'suggestion',
                {
                    subcategory1: cat.categoryCrumb?.ad_subcategory1,
                    subcategory2: cat.categoryCrumb?.ad_subcategory2,
                    subcategory3: cat.categoryCrumb?.ad_subcategory3,
                    subcategory4: cat.categoryCrumb?.ad_subcategory4,
                    subcategory5: cat.categoryCrumb?.ad_subcategory5,
                    category: cat.displayName,
                    categoryId: cat.id,
                },
                index + 1
            )
        );
    }
}
